var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenEnded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#eff7e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39,17V43a8,8,0,0,0,8,8H46.61a8,8,0,0,0,8-8V17Zm20,6.32h5.26v5.27H29.37Zm0,7.17h5.26V35.8H29.37Zm-7.14-7.17H27.5v5.27H22.23Zm0,7.17H27.5V35.8H22.23ZM20.36,35.8H15.1V30.53h5.26Zm0-7.17H15.1V23.36h5.26Zm21.41,17H22.23V40.34H41.77Zm0-9.81H36.5V30.53h5.27Zm0-7.17H36.5V23.36h5.27ZM48.9,35.8H43.64V30.53H48.9Zm0-7.17H43.64V23.36H48.9Z",
    fill: "#5d9431"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEnded);
export default __webpack_public_path__ + "static/media/open_ended.3842b3e674573dd82bc32376ff897ffd.svg";
export { ForwardRef as ReactComponent };